<template>
  <div>
    Message : <v-btn color="primary" small @click="editMode = !editMode"><v-icon small>mdi-pencil</v-icon> Toggle edit
      mode</v-btn>
    <v-textarea rows="9" v-if="editMode" v-model="valueLocal" @change="change" />
    <div v-if="!editMode" style="border:1px solid gray" v-html="valueLocal"></div>
  </div>
</template>

<script>


/**
 * https://github.com/hifarer/vueditor?tab=readme-ov-file
 */
export default {
  props: {
    value: { type: String }
  },
  mounted() {
  },
  data() {
    return {
      editMode: false,
      valueLocal: this.value,
    };
  },
  methods: {
    change() {
      this.$emit('input', this.valueLocal.replace(/\n|\r/g, ""))
    },
  },
};
</script>